<template>
  <div class="mb-question-content">
    <mb-header>
      <div slot="middle" :class="['mb-countdown', {'warning': testTime === 1}]">
        <icon-time class="mb-icon"/>
        {{endTime | formateTime(newCountdown) | timeFactory}}
      </div>
      <button class="mb-submit" slot="right" @click="submitPaper">我要交卷</button>
    </mb-header>
    <div class="mb-progress-wrap">
      <div class="mb-progress" :style="`width:${parseInt(totalFinish / questionNum * 100)}%`"></div>
    </div>
    <div class="mb-top-nav">
      <span>
        <span class="mb-type-name">{{ formateType(question.typeId, question.questionType) }}</span>
        <span class="mb-score">（{{ question.score }}分）</span>
      </span>
      <!-- <div class="mb-tips">视频监考中</div> -->
      <span class="mb-progress">
        <span class="mb-finish">第{{question.questionNo}}题</span>
        <span class="mb-total">/共{{questionNum}}题</span>
      </span>
    </div>
    <div class="mb-scroll-box" ref="scrollBox">
      <div class="question-wrap">
        <div class="mb-question-desc question-render-container"></div>
        <!--填空题-->
        <div class="mb-blank-wrap" v-if="question.typeId === 20">
          <textarea placeholder="请在这里输入答案"
                    class="mb-blank-fill"
                    v-model.trim="currentAnswer"
                    rows="5"></textarea>
        </div>
        <!--单项选择题-->
        <ul class="mb-option-wrap" v-if="question.typeId === 1">
          <li class="mb-option"
              v-for="(option, index) in question.choice.choices"
              :key="index"
              :class="{'is-select': option.submit_id === currentAnswer}"
              @click="selectAnswer(option.submit_id)">
            <div class="mb-option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="mb-option-content">
              <p class="mb-desc">{{option.text}}</p>
              <div class="mb-image" v-if="option.image">
                <viewer :images="option.image">
                  <img :src="option.image"/>
                </viewer>
              </div>
            </div>
          </li>
        </ul>
        <!--多项选择题-->
        <ul class="mb-option-wrap" v-if="question.typeId === 2">
          <li class="mb-option"
              v-for="(option, index) in question.choice.choices"
              :key="index"
              :class="{'is-select': currentAnswer.indexOf(option.submit_id) !== -1}"
              @click="selectAnswer(option.submit_id)">
            <div class="mb-option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="mb-option-content">
              <p class="mb-desc">{{option.text}}</p>
              <div class="mb-image" v-if="option.image">
                <viewer :images="option.image">
                  <img :src="option.image"/>
                </viewer>
              </div>
            </div>
          </li>
        </ul>
        <!--判断题-->
        <ul class="mb-option-wrap" v-if="question.typeId === 6">
          <li class="mb-option"
              v-for="(option, index) in question.yes_no.yes_no"
              :key="index"
              :class="{'is-select': option.submit_id === currentAnswer}"
              @click="selectAnswer(option.submit_id)">
            <div class="mb-option-name-wrap">
              <span>{{order[index]}}</span>
            </div>
            <div class="mb-option-content">
              <p class="mb-desc">{{option.mark_yes_no === 'YES' ? '对' : '错'}}</p>
            </div>
          </li>
        </ul>
        <!--Nemo类型-->
        <div
          :class="{
            'mb-nemo-wrap': true,
            'mb-nemo-update': currentAnswer && currentAnswer.url
          }"
          v-if="question.questionType === 4"
          @click="onClickForNemoQuestion"
        ></div>
        <!--创作题，有上传文件的python题属于新题型，不显示此栏-->
        <div class="tool-wrap">
          <div
            id="iframeWrap"
            class="editor"
            :class="{'full-screen': editorFullScreen}"
            v-show="[0, 2, 3, 6, 7].includes(question.questionType)">
          </div>
          <div v-if="[0, 2, 3, 6, 7].includes(question.questionType)">
            <div
              class="countdown"
              :class="{
                'py-countdown': question.questionType === 2,
                'scratch-countdown': question.questionType === 3,
                'tart-countdown': [6, 7].includes(question.questionType),
                'full-screen-position': editorFullScreen
              }"
              v-show="editorFullScreen"
            >
              <span class="word">剩余时间</span>
              <span class="time" v-if="endTime">{{ endTime | formateTime(newCountdown) | timeFactory }}</span>
            </div>
            <div class="toAnswer" @click="showFullScreen">全屏作答<span class="arrow"></span></div>
            <div class="mask"></div>
          </div>
        </div>
        <!--python新题型-->
        <!-- <div class="new-type-wrap" v-if="question.questionType === 1">
          <button class="data-download" @click="downloadExamData(question.uploadUrl)"><i class="download-icon"></i>考试资料下载</button>
          <div class="upload-wrap">
            <p class="tip">请根据题目提示，打开海龟编辑器进行作答，作答完成根据要求上传答案</p>
            <button class="data-upload" @click="uploadFile" v-if="!currentAnswer"><i class="upload-icon"></i>上传答案</button>
            <div class="answer-wrap" v-else>
              <i class="python-icon"></i>
              <div class="answer-info">
                <p class="file-name">{{currentAnswer.split('/')[currentAnswer.split('/').length - 1]}}</p>
                <p class="upload-time">{{currentAnswer.split('/')[currentAnswer.split('/').length - 2] | date('H:i')}} 上传成功</p>
              </div>
              <span class="change-btn" @click="uploadFile">修改作品</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 答题区域操作按钮 -->
    <div class="mb-btn-wrap" ref="btnWrap" v-show="!editorFullScreen">
      <img @click="$emit('toggleAnswer')" class="mb-icon" src="~assets/images/exam/icon-menu.png" alt="">
      <button
        :disabled="hiddenPrev"
        class="mb-btn"
        @click="saveAnswer('prevQuestion')"
        >上一题</button>
      <button
        :disabled="isLast"
        class="mb-btn"
        @click="saveAnswer('nextQuestion')">
        下一题</button>
    </div>
    <!-- 操作题全屏操作按钮 -->
    <!-- <div class="full-screen-btn" v-show="editorFullScreen">
      <button
        type="button"
        class="btn"
        @click="openDetail"
        :style="openBtnStyle">查看题目</button>
      <button class="btn" @click="saveWork" :style="'background:'+$store.state.theme.themeColor">保存作品</button>
      <button class="btn" @click="outFullScreen" :style="'background:'+$store.state.theme.themeColor">退出全屏</button>
      <button class="reset-ques" @click="showTip = true" :style="'color:'+$store.state.theme.themeColor">重置</button>
      <div>
        <div
          class="question-detail"
          :class="{ show: showDetail }"
        >
          <i class="icon-close" @click="openDetail"></i>
          <div class="content question-render-container"></div>
        </div>
      </div>
    </div> -->
    <!-- 重置提示框 -->
    <!-- <modal
      width="450px"
      speed="fast"
      title="提示"
      noOutClose
      :show="showTip"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      @update:show="showTip = false"
    >
      <div slot="content">
        <p style="font-size: 16px;">重置操作将会清空所有修改恢复初始状态，是否继续？</p>
      </div>
      <div slot="footer">
        <button class="white-btn" @click="showTip = false">取消</button>
        <button class="blue-btn" @click="resetQues">确定</button>
      </div>
    </modal>
    <input
      type="file"
      style="display: none;"
      @change="fileChange"
      ref="fileInput"
    > -->
    <div v-if="loading" class="loading">
      <looping-rhombuses-spinner
        :animation-duration="2500"
        :rhombus-size="30"
        color="#3D81FF"
      />
    </div>
  </div>
</template>

<script>
import MbHeader from '@/components/MbHeader'
import eventBus from '@/utils/eventBus'
import { get } from '@/utils/ajax'
import { formateQuesType } from '@/utils/common'
import { downloadData, qiniuUpload } from '@/utils'
import Vue from 'vue/dist/vue'
// import _ from 'lodash'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import IconTime from '@/assets/svg/exam/icon-time.svg'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component'
import VViewer from 'v-viewer'
import {
  START_CREATION,
  COMPLETED_CREATION,
  // FORCE_COMPLETED_CREATION,
  onPostMessageSynRegister,
  removeOnPostMessageSynRegister,
  postMessageSyn
} from '@/utils/dsbridge'
import * as Sentry from '@sentry/browser'

Vue.use(VViewer, { defaultOptions: {
  title: false,
  toolbar: {
    zoomIn: {
      size: 'large'
    },
    zoomOut: {
      size: 'large'
    },
    reset: {
      size: 'large'
    },
    rotateLeft: {
      size: 'large'
    },
    rotateRight: {
      size: 'large'
    }
  },
  navbar: false
} })
export default {
  components: {
    Viewer,
    IconTime,
    MbHeader,
    LoopingRhombusesSpinner
  },
  props: {
    question: {
      type: Object,
      default () {
        return {}
      }
    },
    questionNum: {
      type: Number,
      default: 0
    },
    totalFinish: {
      type: Number,
      default: 0
    },
    hiddenPrev: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    newCountdown: {
      type: Number
    },
    endTime: {
      type: Number
    },
    currentQuestionId: {
      type: Number,
      default: 0
    },
    operationList: {
      type: Array
    },
    testTime: {
      type: Number,
      default: 0
    }
  },
  filters: {
    // 页面倒计时
    formateTime (value, countdown) {
      const time = value - countdown
      return time
    },
    // 倒计时格式化
    timeFactory (timestamp) {
      timestamp = timestamp / 1000
      if (timestamp <= 0) {
        return '00:00:00'
      }
      let h = Math.floor(timestamp / 3600)
      let m = Math.floor(timestamp / 60 % 60)
      let s = Math.floor(timestamp % 60)
      h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return h + ':' + m + ':' + s
    }
  },
  data () {
    return {
      order: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      currentAnswer: '',
      initialCode: '',
      toolUrl: '',
      editorFullScreen: false,
      forInitWood: false,
      timer: null,
      currentWorkId: '',
      showTip: false,
      showDetail: false,
      openBtnStyle: {},
      curOperateType: null,
      operateType: ['kitten', '', 'python', 'scratch', '', 'explore', 'cplusplus', 'python_oj'],
      loadStatus: [0, 0, 0], // 记录工具loaded状态 对应关系 ['kitten', 'python', 'scratch']
      isReset: false,
      loading: false
    }
  },
  computed: {
    answerHasNotChange () {
      return !this.currentAnswer || (this.question.typeId === 2 && this.currentAnswer.length < 1) || (this.question.typeId === 11 && !this.currentAnswer.url)
    }
  },
  created () {
    eventBus.$on('selectQuestion', (id, isSubmit) => {
      // 有修改切换保存，无修改就拉只拉题目数据
      const answer = this.answerHasNotChange ? null : this.currentAnswer
      this.$emit('saveAnswer', {
        which: !isSubmit ? 'selectQuestion' : 'submitPaper',
        answer,
        currentId: id
      })
    })
  },
  mounted () {
    // this.$nextTick(
    //   this.toolListener()
    // )
    this.$once('hook:beforeDestroy', () => {
      if (this.timer !== null) clearInterval(this.timer)
    })
    this.openBtnStyle = { background: `${this.$store.state.theme.themeColor.split(';')[0]}`, color: '#fff', border: 'none' }
    this.$nextTick(() => {
      const btnElement = this.$refs.btnWrap
      if (btnElement) {
        const style = window.getComputedStyle(btnElement)
        const { clientHeight } = document.documentElement
        btnElement.style.top = `calc(${clientHeight}px - ${style.height}`
      }
    })
    this.onCompletedNemoQuestion()
  },
  watch: {
    question: {
      handler: function (val) {
        // console.log('watch question==>', val)
        this.currentAnswer = val.typeId === 2 ? [] : ''
        if (val.answer) { // 初始化考生已答题目答案
          switch (val.typeId) {
            case 1:
              this.currentAnswer = Number(val.answer)
              break
            case 2:
              val.answer.forEach((t, i) => {
                val.answer[i] = Number(t)
              })
              this.currentAnswer = val.answer
              break
            case 6:
              this.currentAnswer = Number(val.answer)
              break
            case 11:
              this.currentAnswer = (val.questionType === 4) ? { url: val.answer } : val.answer
              break
            default:
              this.currentAnswer = val.answer
          }
        }
        // 渲染题目
        this.renderRawDescription(val.rawDescription)
        this.$nextTick(() => {
          this.$refs.scrollBox.scrollTop = 0
          this.initIFrame()
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 设置页面标识
    setIsNemoPage(isNemoPage) {
      this.$emit('setIsNemoPageNow', isNemoPage)
    },
    // app通知完成创作
    onCompletedNemoQuestion() {
      onPostMessageSynRegister(COMPLETED_CREATION, (res) => {
        // console.log('APP触发 完成答题 => COMPLETED_CREATION', res, this.question)
        const {
          isForceComplete,
          // examId,
          // questionId,
          url
        } = res
        // console.log('设置答案 currentAnswer =>', this.currentAnswer)
        this.currentAnswer = { url }
        this.setIsNemoPage(false)
        isForceComplete ? this.$emit('forceCompletedExam')
          : this.saveAnswer(
            'saveNemo',
            this.question.questionId,
            this.question.questionNo
          )
      })
    },
    // 打开nemo创作页面
    async onClickForNemoQuestion() {
      const payload = {
        mills: this.endTime - this.newCountdown,
        examId: this.question.examId + '',
        questionId: this.question.questionId + '',
        url: `${this.question.answer || this.question.nemo.url}`.trim()
        // url: 'https://static.codemao.cn/nemo/HJINeUC5_.bcm'
      }
      // console.log('去app创作页面 => START_CREATION => payload', payload)
      postMessageSyn(START_CREATION, payload)
      this.setIsNemoPage(true)
    },
    renderRawDescription(raw) {
      if (!raw) {
        return
      }
      const reg = /(<img[^>\\/>]*?src=['"]([^'"]+)['"].*?(?:>|\/>))/g
      const template = this.$xss(raw).replace(reg, (_, $1, $2) => {
        return `<div v-viewer><img src="${$2}"/></div>`
      })
      const RawComponent = Vue.extend({
        template: `<div>${template}</div>`
      })
      this.$nextTick(() => {
        document.querySelectorAll('.question-render-container').forEach(ele => {
          while (ele.hasChildNodes()) {
            ele.removeChild(ele.firstChild)
          }
          ele.appendChild(new RawComponent().$mount().$el)
        })
      })
    },
    // 初始化操作题
    initIFrame() {
      const { questionId, questionType } = this.question
      // 当前题目是操作题
      if ([0, 2, 3, 5, 6, 7].includes(questionType)) {
        if (this.currentQuestionId !== questionId) {
          this.$message.warning('创作题获取失败，请重新加载')
          return
        }
        this.curOperateType = questionType
        this.createIFrame(questionType, 1)
        this.hideIframe(questionType)
      }
      this.operationList.forEach(item => { // 判断下一道题是不是操作题
        if (item.preQuesId === questionId) {
          this.createIFrame(item.questionType, 2)
          this.hideIframe(questionType)
        }
      })
    },
    // 创建操作题dom节点
    createIFrame(type, status) {
      const id = this.operateType[type]
      let url = ''
      switch (type) {
        case 0: // kitten
          url = `${CONFIG.ide}?in_edu_lesson=true`
          break
        case 2: // python
          url = CONFIG.python
          break
        case 3: // scratch
          url = `${CONFIG.scratch}?work_url=https://education.codemao.cn/27/exam/1/1598446666000/scratch_default.sb3`
          break
        case 5: // 闯关
          url = this.question.uploadUrl
          break
        case 6: // C++
          url = CONFIG.cplusplus
          break
        case 7: // Python OJ版
          url = CONFIG.python_oj
          break
      }
      const iframeWrap = document.querySelector('#iframeWrap')
      const hasIframe = iframeWrap && iframeWrap.querySelector(`#${id}`) // 是否已存在该题型的Iframe
      if (!hasIframe) { // 创建新的Iframe
        // 创建构造器
        const Profile = Vue.extend({
          template: '<iframe :src="url" :id="id" width="100%" height="100%" class="if-common" allow="microphone;camera;midi;encrypted-media;"></iframe>',
          data: function () {
            return {
              url: url,
              id: id
            }
          }
        })
        // 创建 Profile 实例，并挂载
        iframeWrap && iframeWrap.appendChild(new Profile().$mount().$el)
      } else { // 直接加载当前题目内容
        if (status === 1) {
          this.loadIfContent(this.curOperateType)
        }
      }
    },
    // 加载操作题内容
    async loadIfContent(type) {
      if (this.editorFullScreen) { // 全屏操作时
        this.loading = true
      }
      const id = this.operateType[type]
      const dom = document.querySelector(`#${id}`)
      switch (id) {
        case 'kitten':
          let bcmUrl = this.question.kitten.start_bcm.url
          if (this.question.answer && !this.isReset) {
            const { bcm_url } = await get(`/edu/exams/works/kitten?code=${this.question.answer}`)
            bcmUrl = bcm_url
          }
          dom.contentWindow.postMessage(
            { type: 'load_bcm', content: `${bcmUrl}` }, `${CONFIG.ide}?in_edu_lesson=true`
          )
          if (this.question.kittenMaterialLoad === 1) { // 打开素材库
            dom.contentWindow.postMessage( // 展示素材库  注意：kitten@3.7.0版本后，素材库material_dialog配置为bool值
              { type: 'kitten_set_ui', content: { sprite_panel: { material_dialog: 'default' } } }, CONFIG.ide
            )
          } else {
            dom.contentWindow.postMessage( // 展示素材库  注意：kitten@3.7.0版本后，素材库material_dialog配置为bool值
              { type: 'kitten_set_ui', content: { sprite_panel: { material_dialog: false } } }, CONFIG.ide
            )
          }
          break
        case 'scratch':
          const sb3Url = this.isReset ? this.question.uploadUrl : (this.question.answer || this.question.uploadUrl)
          dom.contentWindow.postMessage(
            { type: 'load_sb3', content: `${sb3Url}` }, window.CONFIG.scratch
          )
          break
        case 'python':
          const pyCode = this.isReset ? this.question.operation.template_source_code : (this.question.answer || this.question.operation.template_source_code)
          // 设置初始化代码
          dom.contentWindow.postMessage(
            { msg: 'set_python_code', code: `${pyCode}` }, CONFIG.python
          )
          this.loading = false
          if (this.isReset) {
            this.$message.success('重置成功！')
            this.isReset = false
          }
          break
        case 'cplusplus':
          const cppCode = this.isReset
            ? this.question.operation.template_source_code
            : this.question.answer ||
              this.question.operation.template_source_code
          // 设置初始化代码
          dom.contentWindow.postMessage({
            type: 'WORK_OPEN',
            payload: {
              work: {
                work_id: 0,
                name: '新的作品',
                extension: 'cpp',
                content: cppCode,
                version: 0
              }
            }
          }, CONFIG.cplusplus)
          this.loading = false
          if (this.isReset) {
            this.$message.success('重置成功！')
            this.isReset = false
          }
          break
        case 'python_oj':
          const pythonOjCode = this.isReset
            ? this.question.operation.template_source_code
            : this.question.answer ||
              this.question.operation.template_source_code
          // 设置初始化代码
          dom.contentWindow.postMessage({
            type: 'WORK_OPEN',
            payload: {
              work: {
                work_id: 0,
                name: '新的作品',
                extension: 'py',
                content: pythonOjCode,
                version: 0
              }
            }
          }, CONFIG.python_oj)
          this.loading = false
          if (this.isReset) {
            this.$message.success('重置成功！')
            this.isReset = false
          }
          break
      }
    },
    // 隐藏iframe
    hideIframe(type) {
      const id = this.operateType[type]
      const iframeWrap = document.querySelectorAll('.if-common')
      iframeWrap.forEach(item => {
        item.style.display = item.id === id ? 'block' : 'none'
      })
    },
    // 下载考试资料
    downloadExamData (url) {
      downloadData(url)
    },
    // 打开上传选择
    uploadFile () {
      this.$refs.fileInput.click()
    },
    // 上传新题型答案到七牛云
    async fileChange (e) {
      const file = e.target.files[0]
      // const fileName = e.target.files[0].name.split('.')[0]
      this.$refs.fileInput.value = ''
      try {
        this.currentAnswer = await qiniuUpload(file, { noLimitToType: true })
        this.$message.success('上传成功！')
      } catch (e) {
        this.$message.error('上传失败，请重试！')
      }
    },
    setStateStyle (option) {
      let style = ''
      if (option.submit_id === this.currentAnswer) {
        style = `border: 1px solid ${this.$store.state.theme.themeColor}`
        return style
      }
      return `border: 1px solid ${this.$store.state.theme.lightThemeColor}`
    },
    areaChange (e, theme) {
      if (theme) {
        e.target.style = `border-color: ${this.$store.state.theme.themeColor}`
      } else {
        e.target.style = `border-color: ${this.$store.state.theme.lightThemeColor}`
      }
    },
    styleChange (e, option, typeId, theme) {
      if ((typeId === 1 || typeId === 6) && option.submit_id === this.currentAnswer) {
        e.target.querySelector('.option-name-wrap').style = `border-right: none; background-color: ${this.$store.state.theme.themeColor}`
        return
      }
      if (typeId === 2 && this.currentAnswer.indexOf(option.submit_id) !== -1) {
        e.target.querySelector('.option-name-wrap').style = `border-right: none; background-color: ${this.$store.state.theme.themeColor}`
        return
      }
      if (theme) {
        e.target.style = `border: 1px solid ${this.$store.state.theme.themeColor}`
        e.target.querySelector('.option-name-wrap').style = `border-right: 1px solid ${this.$store.state.theme.themeColor}
        background-color: ${this.$store.state.theme.lightThemeColor}`
      } else {
        e.target.style = ''
        e.target.querySelector('.option-name-wrap').style = `border-right: none; background-color: ${this.$store.state.theme.lightThemeColor}`
      }
    },
    toolListener () {
      window.addEventListener('message', e => {
        const message = e.data
        switch (message.type) {
          case 'exam_save_end': // kitten/scratch 保存作品结果
            if (message.content.content.status === 'error') {
              this.$message.error('保存作品失败，请重新保存')
            } else {
              const quesId = message.content.content.question_id
              this.currentAnswer = {
                url: message.content.content.bcm_url || message.content.content.sb3_url,
                workId: message.content.content.work_id,
                questionId: quesId ? quesId.split('&&')[0] : '',
                questionNo: quesId ? quesId.split('&&')[1] : ''
              }
              if (message.platform === 'scratch') {
                this.saveAnswer('saveScratch', this.currentAnswer.questionId, this.currentAnswer.questionNo)
              } else {
                this.saveAnswer('saveKitten', this.currentAnswer.questionId, this.currentAnswer.questionNo)
              }
              // if (this.currentAnswer.questionId) {
              //   this.$notify({
              //     title: '成功',
              //     message: `题号为${this.currentAnswer.questionNo}的题目保存答案成功`,
              //     type: 'success'
              //   })
              // }
            }
            break
          case 'exam_login_fail':
            this.$message.error('登录失效，请重新登录')
            this.$router.replace({ name: 'login', params: { goLogin: true } })
            break
          case 'kitten_loaded':
            this.initKitten()
            break
          case 'scratch_loaded': // scratch工具初始化完成
            if (this.curOperateType === 3) {
              this.loadIfContent(3)
            }
            break
          case 'exam_load_bcm_end': // 加载bcm的结果
            if (message.content.content.status === 'error') {
              this.$emit('openSlowTip', 'loadQues')
            } else if (this.isReset) {
              this.$message.success('重置成功！')
              this.isReset = false
            }
            this.$emit('closeShowLoading')
            this.loading = false
            break
          case 'exam_load_sb3_end': // 加载sb3的结果
            if (message.content.content.status === 'error') {
              this.$emit('openSlowTip', 'loadQues')
            } else if (this.isReset) {
              this.$message.success('重置成功！')
              this.isReset = false
            }
            this.$emit('closeShowLoading')
            this.loading = false
            break
          case 'IFRAME_READY': // C++、Python OJ版工具初始化完成
            this.initTart(message.payload.page)
            break
          case 'WORK_CURRENT_DATA': // C++、Python OJ版获取作品成功
            this.saving = false
            this.currentAnswer = message.payload.work.content
            if (this.curOperateType === 6) {
              this.saveAnswer('saveCplusplus')
            } else if (this.curOperateType === 7) {
              this.saveAnswer('savePythonOj')
            }
            break
          case 'WORK_GET_CURRENT_DATA_FAILED': // C++获取作品失败
            this.saving = false
            this.$message.error('保存作品失败，请重新保存')
            Sentry.captureEvent({
              message: '作品保存失败',
              extra: message.payload
            })
            break
        }
        switch (message.msg) {
          case 'wood_is_ready':
            if (!this.loadStatus[1]) {
              this.initPython()
              this.loadStatus[1] = 1
            }
            break
          case 'python_code':
            if (message.code !== this.currentAnswer) {
              this.currentAnswer = message.code
              this.saveAnswer('savePython')
            }
            break
        }
        if (!this.loadStatus[0] && message.content === 'kitten_is_ready') { // kitten工具默认作品初始化完成
          this.loadStatus[0] = 1
          if (this.curOperateType === 0) {
            this.loadIfContent(0)
          }
        }
      })
    },
    // 初始化Tart工具 type= 'py_oj' | 'cpp_oj'
    initTart(type) {
      let tart = null
      let extension = ''
      let domain = '*'
      let exportName = ''
      switch (type) {
        case 'py_oj':
          tart = document.getElementById('python_oj')
          extension = 'py'
          domain = CONFIG.python_oj
          exportName = 'exportAsPythonFile'
          break
        case 'cpp_oj':
          tart = document.getElementById('cplusplus')
          extension = 'cpp'
          domain = CONFIG.cplusplus
          exportName = 'exportAsCppFile'
          break
        default:
          throw new Error('未知编辑器')
      }

      if (!tart) return

      tart.contentWindow.postMessage(
        {
          type: 'FEATURE_SET_CONFIG',
          payload: {
            headerDisabled: false, // 默认展示头部栏，true 则隐藏
            headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
            headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
            headerFileMenuItems: [
              // 'createProject',
              // 'openProjectManager',
              // 'workSaveAs',
              // 'divider',
              // 'openLocalFile',
              exportName
              // 'divider',
              // 'importMiaoLink',
              // 'exportAsMiaoLink',
            ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
            userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
            workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
            workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
            disabledRegExp: true // 默认隐藏正则配置，false 则展示
          }
        },
        domain
      )

      // 设置初始化代码
      this.currentAnswer = this.currentAnswer
        ? this.currentAnswer
        : this.question.operation.template_source_code

      tart.contentWindow.postMessage({
        type: 'WORK_OPEN',
        payload: {
          work: {
            work_id: 0,
            name: '新的作品',
            extension,
            version: 0,
            content: this.currentAnswer
          }
        }
      }, domain)
    },
    initKitten() { // 初始化kitten配置项
      const kitten = document.getElementById('kitten')
      if (!kitten) return
      kitten.contentWindow.postMessage( // 展示文件按钮
        { type: 'kitten_set_ui', content: { header: { file: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示保存作品到本地
        { type: 'kitten_set_ui', content: { header: { export_file: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示设置按钮
        { type: 'kitten_set_ui', content: { header: { setting: true } } }, CONFIG.ide
      )
      kitten.contentWindow.postMessage( // 展示语言切换
        { type: 'kitten_set_ui', content: { header: { language: true } } }, CONFIG.ide
      )
    },
    initPython () {
      const python = document.getElementById('python')
      if (!python) return
      // 设为代码模式
      setTimeout(() => {
        python.contentWindow.postMessage(
          { msg: 'set_default_mode', mode: 'code' }, CONFIG.python
        )
      }, 100)
      // 隐藏切换积木模式按钮
      setTimeout(() => {
        python.contentWindow.postMessage(
          { msg: 'set_mode_btn_display', mode: 'false' }, CONFIG.python
        )
      }, 100)
      // 隐藏自带的缩放按钮
      setTimeout(() => {
        python.contentWindow.postMessage(
          { msg: 'set_fullscreen_btn_display', is_display: false }, CONFIG.python
        )
      }, 100)
      // 隐藏帮助按钮
      setTimeout(() => {
        python.contentWindow.postMessage(
          { msg: 'set_help_btn_display', is_display: false }, CONFIG.python
        )
      }, 100)
      // 打开海龟绘图
      setTimeout(() => {
        python.contentWindow.postMessage(
          { msg: 'set_turtle_canvas_display', is_display: true }, CONFIG.python
        )
      }, 100)
      if (this.question.questionType === 2) { // 若当前题目是py，在初始化完iframe后设置题目内容
        // 设置初始化代码
        setTimeout(() => {
          this.currentAnswer = this.currentAnswer ? this.currentAnswer : this.question.operation.template_source_code
          python.contentWindow.postMessage(
            { msg: 'set_python_code', code: this.currentAnswer }, CONFIG.python
          )
        }, 100)
      }
    },
    // python在线编辑全屏开启定时
    showFullScreen () {
      const python = document.getElementById('python')
      if (this.question.questionType === 2) {
        python.style.width = document.body.clientWidth
        python.style.height = document.body.clientHeight
        setTimeout(() => {
          python.contentWindow.postMessage(
            { msg: 'set_fullscreen_done',
              is_fullscreen: true }, CONFIG.python
          )
        }, 100)
      }
      this.autoSave()
      this.editorFullScreen = true
      this.$emit('changeStyle', true)
    },
    // 退出全屏关闭定时
    outFullScreen () {
      if (this.timer !== null) clearInterval(this.timer)
      if (this.question.questionType === 2) {
        const python = document.getElementById('python')
        setTimeout(() => {
          python.contentWindow.postMessage(
            { msg: 'set_fullscreen_done',
              is_fullscreen: true }, CONFIG.python
          )
        }, 100)
      }
      this.editorFullScreen = false
      this.showDetail = false
      this.$emit('changeStyle', false)
      this.saveWork()
    },
    // 选择题的保存
    selectAnswer (id) {
      if (this.question.typeId === 2) {
        this.currentAnswer = this.currentAnswer instanceof Array ? this.currentAnswer.slice() : []
        if (this.currentAnswer.indexOf(id) === -1) {
          this.currentAnswer.push(id)
        } else {
          this.currentAnswer.splice(this.currentAnswer.indexOf(id), 1)
        }
      } else {
        this.currentAnswer = id
      }
      // 去掉逻辑：单选题和判断题选择后自动跳转下一题
      // if (this.question.typeId === 1 || this.question.typeId === 6) {
      //   this.saveAnswer('nextQuestion')
      // }
      // this.saveAnswer('selectQuestion')
    },
    saveAnswer (which, questionId, questionNo) {
      const answer = this.answerHasNotChange ? null : this.currentAnswer
      /* console.log(`
        【emit】 saveAnswer ==>
        which: ${which},
        answer: ${JSON.stringify(answer)}
      `) */
      this.$emit('saveAnswer', {
        which,
        answer,
        currentId: questionId || this.question.questionId,
        questionNo: questionNo || this.question.questionNo
      })
    },
    // 3分钟保存
    autoSave () {
      this.timer = setInterval(() => {
        this.saveWork()
      }, 180000)
    },
    // 保存到工具
    saveWork () {
      if (this.question.questionType === 2) { // python在线编辑操作题
        const python = document.getElementById('python')
        python.contentWindow.postMessage(
          { msg: 'get_python_code' }, CONFIG.python
        )
      } else if (this.question.questionType === 6) { // C++操作题
        const cpp = document.getElementById('cplusplus')
        cpp.contentWindow.postMessage({ type: 'WORK_GET_CURRENT_DATA' }, CONFIG.cplusplus)
      } else if (this.question.questionType === 7) { // Python OJ版操作题
        const pythonOj = document.getElementById('python_oj')
        pythonOj.contentWindow.postMessage({ type: 'WORK_GET_CURRENT_DATA' }, CONFIG.python_oj)
      } else { // scratch或者kitten，保存逻辑一样
        if (!this.editorFullScreen) this.$emit('showSaveLoading')
        const editor = this.question.questionType === 0 ? document.getElementById('kitten') : document.getElementById('scratch')
        editor.contentWindow.postMessage(
          { type: 'exam_save', content: { 'question_id': `${this.question.questionId}&&${this.question.questionNo}` } }, this.question.questionType === 0 ? `${CONFIG.ide}?in_edu_lesson=true` : CONFIG.scratch
        )
        // console.log('save work', `${this.question.questionId}&&${this.question.questionNo}`)
      }
    },
    // 重置操作题题目
    async resetQues() {
      this.isReset = true
      this.showTip = false
      this.loading = true
      this.loadIfContent(this.question.questionType)
      // this.saveWork() // 保存到工具
    },
    openDetail() {
      this.showDetail = !this.showDetail
      this.openBtnStyle = { background: this.showDetail ? '#fff' : `${this.$store.state.theme.themeColor.split(';')[0]}`,
        color: this.showDetail ? `${this.$store.state.theme.themeColor.split(';')[0]}` : '#fff',
        border: this.showDetail ? `1px solid ${this.$store.state.theme.themeColor.split(';')[0]}` : 'none' }
    },
    // 提交要保存当前
    submitPaper () {
      eventBus.$emit('selectQuestion', this.currentQuestionId, true)
    },
    formateType(id, questionType = 0) {
      return formateQuesType(id, questionType)
    }
  },
  destroyed() {
    removeOnPostMessageSynRegister(COMPLETED_CREATION)
  }
}
</script>
<style lang="scss" scoped>
.mb-question-content{
  width: 100%;
  height: 100%;
}
.mb-countdown{
  font-size: 28px;
  font-weight: 400;
  color: #999999;
  display: flex;
  align-items: center;
  color: #000;
  .mb-icon{
    width: 30px;
    height: 30px;
    margin-right: 16px;
    stroke: #979797;
  }
  &.warning{
    color: #DB0A0A;
    .mb-icon{
      stroke: #DB0A0A;
    }
  }
}
.mb-submit{
  height: 60px;
  padding: 0 40px;
  font-size: 32px;
  color: #fff;
  border-radius: 30px;
  border: 1.6px solid #F7AC1E;
  background: linear-gradient(to bottom, #F9AC1E, #FEC71E);
}
.mb-progress-wrap{
  width: 100%;
  background: #F5F5F5;
  height: 8px;
  .mb-progress{
    background: #3D81FF;
    height: 100%;
  }
}
.mb-top-nav{
  height: 84px;
  padding: 0 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #F5F5F5;
  position: relative;
  .mb-type-name{
    font-size: 24px;
    font-weight: 500;
    color: #333333;
  }
  .mb-score{
    font-size: 20px;
    font-weight: 400;
    color: #333333;
  }
  .mb-tips{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding-left: 34px;
    padding-right: 12px;
    line-height: 40px;
    font-size: 22px;
    background: rgba(153, 153, 153, 0.1);
    border-radius: 4px;
    &::before{
      position: absolute;
      left: 12px;
      top: 14px;
      content: '';
      width: 12px;
      height: 12px;
      background: #FF2525;
      border-radius: 50%;
    }
  }
  .mb-finish{
    font-size: 20px;
    color: #333333;
  }
  .mb-total{
    font-size: 20px;
    color: #999999;
  }
}
.mb-scroll-box {
  padding: 30px 30px 140px;
  height: calc(100% - 178px);
  overflow-y: auto;
}
.mb-btn-wrap{
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 30px;
  background: #FFFFFF;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  .mb-icon{
    width: 80px;
    height: 80px;
    vertical-align: middle;
  }
  .mb-btn{
    width: 280px;
    height: 80px;
    border-radius: 4px;
    font-size: 32px;
    &:last-of-type{
      color: #fff;
      background: #3F83FF;
      box-shadow: 0 12px 20px #C2D7FF;
    }
    &:first-of-type{
      color: #3F83FF;
      border: 2px solid #3F83FF;
      background: #EDF3FF;
    }
    &:disabled{
      color: #999999;
      background: rgba(0, 0, 0, 0.05);
      border: 2px solid #E9E9E9;
      box-shadow: none;
    }
  }
}

.mb-question-desc {
  margin-bottom: 50px;
  font-size: 32px;
  font-weight: 400;
  color: #333333;
  line-height: 44px;
  /deep/ *{
    word-break: break-all;
    white-space: pre-wrap;
  }
  /deep/ img {
    max-width: 100%;
    max-height: 300px;
    width: auto;
    height: auto;
    vertical-align: middle;
  }
}
.mb-blank-wrap {
  margin-bottom: 50px;
  .mb-blank-fill {
    padding: 24px 32px;
    width: 100%;
    border: 1px solid #d9d9d9;
    background: #FFFFFF;
    border-radius: 4px;
    border: 2px solid rgba(61, 129, 255, 0.2);
    line-height: 45px;
    font-size: 32px;
    resize: none;
    min-height: 350px;
    word-break: break-all;
    color:#333;
    &:focus, &:hover {
      border-color: #468DFF;
    }
    &::placeholder {
      font-size: 32px;
      color: #ccc;
    }
  }
}
.tool-wrap {
  max-height: 333px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  .editor {
    width: 100%;
    height: 100%;
    // transition: all 0.4s linear;
    &.full-screen {
      width: calc(100% - 100px);
      position: fixed;
      top: 0;
      left: 0;
      // bottom: 0;
      // right: 98px;
      z-index: 3;
    }
  }
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .5);
  }
  .toAnswer {
    width: 100%;
    line-height: 33px;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 24px;
    font-weight: 300;
    cursor: pointer;
    .arrow {
      width: 23px;
      height: 18px;
      background: url('~images/full_screen_arrow@2x.png') no-repeat center / cover;
      margin-left: 10px;
    }
  }
}
.full-screen-btn {
  width: 100px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -100px;
  position: relative;
  button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.15);
    cursor: pointer;
    transition: all .3s ease-in-out;
    padding: 8px 14px;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
    &:hover {
      font-size: 16px;
      padding: 8px 12px;
    }
  }
  .btn {
    color: #fff;
    // background: #397EFD;
  }
  .open-btn {
    background: #fff;
    color: $themeColor;
    border: 1px solid $themeColor;
    padding: 8px 14px;
  }
  .question-detail {
    position: absolute;
    right: 100px;
    top: 57px;
    bottom: 40px;
    width: 0;
    height: calc(100% - 100px);
    background-color: #fff;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .1);
    text-align: left;
    transition: width ease .3s;
    &.show {
      width: 612px;
      padding: 20px 20px 80px 20px;
      .icon-close {
        display: inline-block;
      }
    }
    .icon-close {
      display: none;
      width: 16px;
      height: 16px;
      background: url("~@/assets/images/icon-black-close.png") center / cover no-repeat;
      float: right;
      cursor: pointer;
    }
    .content {
      margin-top: 40px;
      font-size: 18px;
      color: $titleColor;
      line-height: 27px;
      overflow: scroll;
      height: 100%;
      /deep/ img {
        max-width: 100%;
      }
    }
  }
  .reset-ques {
    font-size: 14px;
    color: #397EFD;
    margin-top: 40px;
    background-color: #fff;
  }
}
.new-type-wrap  {
  .upload-wrap {
    width: 100%;
    padding: 30px 0 30px 13px;
    color: #111;
    font-size: 16px;
    background-color: #FAFAFA;
    .tip {
      margin-bottom: 20px;
    }
    .answer-wrap {
      padding: 5px 0 0 75px;
      height: 55px;
      position: relative;
      display: flex;
      .python-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 55px;
        height: 55px;
        background: url('~images/python-icon.png') center / cover no-repeat;
      }
      .answer-info {
        width: 256px;
        color: #333;
        font-size: 16px;
        line-height: 25px;
        .file-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .upload-time {
          color: #999;
          font-size: 14px;
        }
      }
      .change-btn {
        line-height: 25px;
        font-size: 16px;
        color: #377DFD;
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }
  .data-upload, .data-download {
    display: flex;
    align-items: center;
    height: 42px;
    padding: 0 30px;
    border: 1px solid #397EFD;
    border-radius: 4px;
    color: #397EFD;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    background-color: #fff;
    .download-icon, .upload-icon {
      display: inline-block;
      width: 19px;
      height: 18px;
      background: url('~images/nct-download.png') no-repeat center / cover;
      margin-right: 9px;
    }
    .upload-icon {
      background: url('~images/nct-upload.png') no-repeat center / cover;
    }
  }
  .data-download {
    margin: 0 0 25px 13px;
  }
}
.mb-option-wrap {
  display: inline-block;
  margin-bottom: 50px;
  width: 100%;
  .mb-option {
    display: flex;
    width: 100%;
    min-height: 116px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 6px solid transparent;
    overflow: hidden;
    &:not(:last-child){
      margin-bottom: 18px;
    }
    &.is-select{
      border-color: #6197FB;
    }
    .mb-option-name-wrap {
      width: 66px;
      background-color: #D8E6FF;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #D8E6FF;
      border-right: none;
    }
    .mb-option-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 20px 32px;
      justify-content: center;
      border: 2px solid #D8E6FF;
      border-left: none;
      .mb-desc {
        width: 100%;
        line-height: 36px;
        color: #333333;
        font-size: 24px;
      }
      .mb-image {
        border-radius: 4px;
        overflow: hidden;
        /deep/ img{
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 200px;
          vertical-align: middle;
        }
      }
    }
  }
}
.mb-nemo-wrap {
  width: 295px;
  height: 295px;
  border-radius: 4px;
  border: 2px solid #D8E6FF;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('~images/exam/nemo.png') no-repeat center / cover;
  &::after {
    content: '去创作 > ';
    display: flex;
    align-items: center;
    justify-content: center;
    width: 190px;
    height: 80px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 40px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: #FFFFFF;
  }
  &.mb-nemo-update::after {
    content: '去修改 > '
  }
}
.white-btn {
  @include cancel-btn(96px, 36px, 14px, 4px);
  margin-right: 20px;
  margin-bottom: 10px;
}
.blue-btn {
  @include theme-fill-btn(96px, 36px, 14px, 4px);
}
.countdown {
  position: fixed;
  top: 8px;
  right: 120px;
  z-index: 3;
  color: #AC6F29;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(172,111,41,0.25);
  border-radius: 45px;
  width: 242px;
  height: 36px;
  .word {
    font-size: 16px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color:rgba(172,111,41,1);
  }
  .time {
    font-size: 24px;
    font-family: PingFangSC-Semibold,PingFang SC;
    font-weight: 600;
    color:rgba(172,111,41,1);
    margin-left: 8px;
  }
}
.py-countdown {
  top: 6px;
  height: 28px;
}
.scratch-countdown {
  top: 6px;
  background: rgba(0,62,175,0.25);
  .word {
    color: rgba(255,255,255,1);
  }
  .time {
    color:rgba(255,255,255,1);
  }
}
.tart-countdown {
  background: rgba(0, 0, 0, 0.25);
  .word {
    color: #fff;
  }
  .time {
    color: #fff;
  }
}
.full-screen-position {
  right: 50%;
  transform: translateX(50%);
}
.fadeInRight {
  animation-name: fadeInRight;
  animation-duration: 0.5s;
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%,0,0);
    transform: translate3d(100%,0,0)
  }
  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
  }
}
.fadeOutRight {
  animation-name: fadeOutRight;
  animation-duration: 0.5s;
}
@keyframes fadeOutRight {
  0% {
    opacity: 1
  }
  to {
    opacity: 0;
    -webkit-transform: translate3d(100%,0,0);
    transform: translate3d(100%,0,0)
  }
}
.loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
}
</style>
